//svg4everybody();

const APP = {

	name: 'SeoZoom by eazyweb'

};
function ez_homeSlider() {
    var slider = $('._js-home-slider');

    if ( slider.length ) {

        slider.on('init afterChange', function(){
            const $this    = $(this);
            const header   = $('._js-website-header');
            const current  = $this.find('.slick-active');
            const type     = current.attr('data-type');
            const lightCls = '_light';
            const darkCls  = '_dark';

            if ( type === 'light' ) {
                $this.removeClass(darkCls).addClass(lightCls);
                header.removeClass(darkCls).addClass(lightCls);
            }
            else if ( type === 'dark' ) {
                $this.removeClass(lightCls).addClass(darkCls);
                header.removeClass(lightCls).addClass(darkCls);
            }
        });

        slider.slick({
            slide: '.ez_home-slider__element',
            rows: 0,
            autoplay: true,
            autoplaySpeed: 10000,
            pauseOnHover: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev"><svg class="i _arrow-left"><use xlink:href="#arrow-left"></use></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg class="i _arrow-right"><use xlink:href="#arrow-right"></use></svg></button>',
            dots: true,
            lazyLoad: 'ondemand',
            adaptiveHeight: true,
            responsive : [
                {
                    breakpoint: 1199,
                    settings : {
                        arrows: false
                    }
                }
             ],
            customPaging:function (a, b) {
                return '<div class="wrapper" data-anim="base wrapper"><div class="circle" data-anim="base left"></div><div class="circle" data-anim="base right"></div></div>'
            }
        });
    }
}
function ez_headerWidth() {
    var header      = $('.ez_website-header'),
        workarea    = $('.ez_workarea').width();

    header.css({
        'max-width' :   workarea
    });
}
function ez_headerCollapse() {

    var wrapper     = $('.ez_website-wrapper'),
        header      = $('.ez_website-header'),
        workarea    = $('.ez_workarea'),
        headerH     = header.height(),
        headerO     = Math.abs(workarea.offset().top);

    if ( headerO >= headerH ) {
        wrapper.addClass('_scrolled');
    } else {
        wrapper.removeClass('_scrolled');
    }

}
function ez_pricesSlider() {

    var slider = $('._js-prices-slider');

    if ( slider.length) {
        slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="slick-prev"><svg class="i _arrow-left"><use xlink:href="#arrow-left"></use></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg class="i _arrow-right"><use xlink:href="#arrow-right"></use></svg></button>',
            dots: false,
            centerMode: false,
            responsive : [
                {
                    breakpoint: 1199,
                    settings : {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 767,
                    settings : {
                        slidesToShow: 1,
                        arrows: false,
                        dots: true
                    }
                }
            ]
        });

    }

}
function ez_carousel() {
    var slider = $('._js-carousel');

    if ( slider.length) {
        slider.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="slick-prev"><svg class="i _arrow-left"><use xlink:href="#arrow-left"></use></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg class="i _arrow-right"><use xlink:href="#arrow-right"></use></svg></button>',
            dots: false,
            centerMode: false,
            lazyLoad: 'ondemand',
            responsive : [
                {
                    breakpoint: 991,
                    settings : {
                        slidesToShow: 3,
                        arrows: false,
                        dots: true
                    }
                },
                {
                    breakpoint: 599,
                    settings : {
                        slidesToShow: 2,
                        arrows: false,
                        dots: true
                    }
                }
            ]
        });

    }
}
function ez_selectStyler() {

    var select = $('.ez_select select');

    if (select.length) {
        select.styler({
            selectSmartPositioning : false,
            selectSearch           : false
        });
    }

}
function ez_reviewsSlider() {

    var slider = $('._js-reviews-slider');

    if ( slider.length) {
        slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="slick-prev"><svg class="i _arrow-left"><use xlink:href="#arrow-left"></use></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg class="i _arrow-right"><use xlink:href="#arrow-right"></use></svg></button>',
            dots: false,
            centerMode: false,
            responsive : [
                {
                    breakpoint: 767,
                    settings : {
                        arrows: false,
                        dots: true
                    }
                }
            ]
        });

    }

}
function ez_lazyLoad() {

    var image = $('._ez_lazy-image');

    if ( image.length ) {
        image.lazyload({
            effect : "fadeIn"
        });
    }
}


function ez_navigation(width) {

    var navigation   = $('#_js-navigation'),
        dropdown     = $('._js-navigation-dropdown'),
        trigger      = $('._js-navigation-trigger'),
        clickAllowed = false,
        hoverAllowed = false;

    dropdown.on('mouseenter mouseleave', function(e){
        if (hoverAllowed) {
            if ( e.type === 'mouseenter') {
                $(this).addClass('_expanded');
            }
            if ( e.type === 'mouseleave') {
                $(this).removeClass('_expanded');
            }
        }
    });

    trigger.on('click', function(){
        if (clickAllowed) {
            var parent = $(this).parents('._dropdown');
            if ( !parent.hasClass('_expanded') ) {
                parent.addClass('_expanded');
            } else {
                parent.removeClass('_expanded');
            }
        }
    });


    $(window).on('load resize', function(){
        var screen  = $(window).width();

        if ( screen >= width ) {
            hoverAllowed = true;
            clickAllowed = false;
        }
        if ( screen < width ) {
            hoverAllowed = false;
            clickAllowed = true;
        }
    });

}
function ez_mobileAside(width) {

    const aside     = $('._js-mobile-aside');
    const nav       = $('#_js-navigation');
    const location  = $('#_js-header-location');
    const contacts  = $('#_js-header-contacts');
    const controls  = $('#_js-header-controls');
    const trigger   = $('._js-aside-trigger');
    const wrapper   = $('._js-website-wrapper');

    trigger.on('click', function(){
        if ( !$(this).hasClass('_active') ) {
            $(this).addClass('_active');
            ez_websiteWidth();
            wrapper.addClass('_mobile-aside-opened');
        }
        else {
            $(this).removeClass('_active');
            wrapper.removeClass('_mobile-aside-opened').css('max-width', '');
        }
    });

    $(window).on('load resize', function(){
        const screen    = $(window).width();

        if ( screen <= width ) {

            if ( !aside.find(nav).length ) {
                aside.append(nav);
            }
            if ( !aside.find(location).length ) {
                aside.append(location);
            }
            if ( !aside.find(contacts).length ) {
                aside.append(contacts);
            }
        }
        else {

            trigger.removeClass('_active');
            wrapper.removeClass('_mobile-aside-opened').css('max-width', '');

            if ( !controls.find(nav).length ) {
                nav.insertBefore(controls);
            }
            if ( !controls.find(contacts).length ) {
                controls.prepend(contacts);
            }
            if ( !controls.find(location).length ) {
                controls.prepend(location);
            }

        }
    });

}
function ez_portfolioSlider() {

    var slider = $('._js-portfolio-slider');

    if ( slider.length) {
        slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="slick-prev"><svg class="i _arrow-left"><use xlink:href="#arrow-left"></use></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg class="i _arrow-right"><use xlink:href="#arrow-right"></use></svg></button>',
            dots: false,
            variableWidth: true,
            infinite: true,
            responsive : [
                {
                    breakpoint: 767,
                    settings : {
                        arrows: false,
                        dots: true
                    }
                }
            ]
        });

    }

}
function ez_teamSlider() {

    var slider = $('._js-our-team-slider');

    if ( slider.length) {
        slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="slick-prev"><svg class="i _arrow-left"><use xlink:href="#arrow-left"></use></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg class="i _arrow-right"><use xlink:href="#arrow-right"></use></svg></button>',
            dots: false,
            responsive : [
                {
                    breakpoint: 767,
                    settings : {
                        arrows: false,
                        dots: true
                    }
                }
            ]
        });

    }

}
function ez_newsSlider() {

    var slider = $('._js-home-news-slider');

    if ( slider.length) {
        slider.slick({
            variableWidth: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<button type="button" class="slick-prev"><svg class="i _arrow-left"><use xlink:href="#arrow-left"></use></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg class="i _arrow-right"><use xlink:href="#arrow-right"></use></svg></button>',
            dots: false,
            centerMode: true,
            centerPadding: '0',
            responsive : [
                {
                    breakpoint: 767,
                    settings : {
                        arrows: false,
                        dots: true
                    }
                },
                {
                    breakpoint: 599,
                    settings : {
                        variableWidth: false,
                        arrows: false,
                        dots: true,
                        adaptiveHeight: true
                    }
                }
            ]
        });
    }

}
function ez_searchBar() {

    let button    = $('._js-header-search-button'),
        close     = $('._js-search-bar-close'),
        input     = $('._js-search-bar-input'),
        wrapper   = $('._js-website-wrapper');

    button.on('click', function(){
        if ( !wrapper.hasClass('_search-bar-opened') ) {
            ez_websiteWidth();
            wrapper.addClass('_search-bar-opened');
        }
    });
    close.on('click', function(){
        if ( wrapper.hasClass('_search-bar-opened') ) {
            wrapper.removeClass('_search-bar-opened').css('max-width', '');

            if ( input.val() != '' ) {
                input.val(null);
            }
        }
    });


}
function ez_websiteWidth() {

    let websiteWidth = $('.ez_workarea').width(),
        wrapper      = $('._js-website-wrapper');

        wrapper.css('max-width', websiteWidth);

}
function ez_map(id, cords) {

    if ( $('#'+id).length ) {

        var ez_customMap = {
            init: function() {
                var mapOptions = {
                    zoom: 12,
                    center: cords,
                    disableDefaultUI: true,
                    scrollwheel: false,
                    styles: [
                        {
                            "featureType": "water",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#e9e9e9"
                                },
                                {
                                    "lightness": 17
                                }
                            ]
                        },
                        {
                            "featureType": "landscape",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#f5f5f5"
                                },
                                {
                                    "lightness": 20
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "lightness": 17
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry.stroke",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "lightness": 29
                                },
                                {
                                    "weight": 0.2
                                }
                            ]
                        },
                        {
                            "featureType": "road.arterial",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "lightness": 18
                                }
                            ]
                        },
                        {
                            "featureType": "road.local",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "lightness": 16
                                }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#f5f5f5"
                                },
                                {
                                    "lightness": 21
                                }
                            ]
                        },
                        {
                            "featureType": "poi.park",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#dedede"
                                },
                                {
                                    "lightness": 21
                                }
                            ]
                        },
                        {
                            "elementType": "labels.text.stroke",
                            "stylers": [
                                {
                                    "visibility": "on"
                                },
                                {
                                    "color": "#ffffff"
                                },
                                {
                                    "lightness": 16
                                }
                            ]
                        },
                        {
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "saturation": 36
                                },
                                {
                                    "color": "#333333"
                                },
                                {
                                    "lightness": 40
                                }
                            ]
                        },
                        {
                            "elementType": "labels.icon",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "transit",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#f2f2f2"
                                },
                                {
                                    "lightness": 19
                                }
                            ]
                        },
                        {
                            "featureType": "administrative",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#fefefe"
                                },
                                {
                                    "lightness": 20
                                }
                            ]
                        },
                        {
                            "featureType": "administrative",
                            "elementType": "geometry.stroke",
                            "stylers": [
                                {
                                    "color": "#fefefe"
                                },
                                {
                                    "lightness": 17
                                },
                                {
                                    "weight": 1.2
                                }
                            ]
                        }
                    ]
                };

                this.map = new google.maps.Map(document.getElementById(id), mapOptions);

                var image = {
                        url: '/local/templates/eazyweb/images/contacts/marker.png',
                        size: new google.maps.Size(24, 34),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(15, 34)
                    },
                    container =
                        '<div class="ez_map-popup">' +
                            '<h3 class="ez_map-popup__heading">Центральный офис в Москве</h3>' +
                            '<p class="ez_map-popup__text">Проектируемый проезд № 4062, 6, стр. 16</p>' +
                            '<p class="ez_map-popup__text">Пн-Пт 09:00 - 18:00</p>' +
                            '<p class="ez_map-popup__text"><a href="tel:+7 (495) 005-63-42">+7 (495) 005-63-42</a></p>' +
                        '</div>',
                    marker = new google.maps.Marker({
                        position: cords,
                        map:  this.map,
                        icon: image
                    });
                var balloon = new SnazzyInfoWindow({
                    marker: marker,
                    content: container,
                    placement: 'left'
                });


                google.maps.event.addListener(marker, 'click', function() {
                    balloon.open( this.map, marker );
                });
            }
        };

        ez_customMap.init();

    }
}
function ez_contacstSlider() {

    var slider = $('._js-contacts-slider');

    if ( slider.length) {
        slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true
        });

    }
}
function ez_modal(id) {
    if (id.length) {
        id.bPopup({
            positionStyle: 'fixed',
            easing: 'easeOutBack',
            speed: 350,
            opacity: .75,
            appending: true,
            appendTo: '.ez_website-wrapper',
            modalColor: 'transparent',
            onOpen: function() {
                var window = $('.ez_workarea').width();
                $('.ez_website-wrapper').addClass('_blurry');
                setTimeout(function(){
                    $('.ez_website-wrapper').addClass('_modal-opened').css('max-width', window);
                }, 400);
            },
            onClose: function() {
                $('.ez_website-wrapper').removeClass('_modal-opened _blurry').css('max-width', '');
            }
        });
    }

}
function ez_asideCarousel() {
    const carousel = $('._js-aside-carousel');

    if ( carousel.length ) {
        carousel.slick({
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            prevArrow: '<button type="button" class="slick-prev"><svg class="i _arrow-left"><use xlink:href="#arrow-left"></use></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg class="i _arrow-right"><use xlink:href="#arrow-right"></use></svg></button>',
            dots: false,
            responsive : [
                {
                    breakpoint: 991,
                    settings : {
                        variableWidth: true
                    }
                },
                {
                    breakpoint: 599,
                    settings : {
                        variableWidth: false,
                        adaptiveHeight: true
                    }
                }
            ]
        });
    }
}
function ez_yandexSearch() {

    const yandexSearch = $("#_js_yandex-search");

    if (yandexSearch.length) {
        $("._js_rating-value").on("click", function () {
            yandexSearch.val($(this).text());
        })
    }

}
$(function() {

    ez_homeSlider();
    ez_pricesSlider();
    ez_carousel();
    ez_selectStyler();
    ez_reviewsSlider();
    ez_lazyLoad();
    ez_mobileAside(1199);
    ez_navigation(1199);
    ez_portfolioSlider();
    ez_teamSlider();
    ez_newsSlider();
    ez_searchBar();
    ez_map('_js-map', {lat: 55.693397, lng: 37.660645});
    ez_contacstSlider();
    ez_asideCarousel();
    ez_yandexSearch();
    //modals

    $('._js-callback-link').on('click', function(){
        ez_modal($('._js-callback-modal'));
    });

    $('._js-order-link').on('click', function(){
        const modal = $('._js-order-modal'),
            service = $(this).data('service'),
            prop = modal.find('#property_40');

        if (service && prop) {
            prop.val(service);
        }

        ez_modal(modal);
    });
});

$(window).on('load resize', function(){
    ez_headerWidth();
});

$('.ez_website-wrapper').on('scroll', function(){
    ez_headerCollapse();
});